import React, { useEffect } from 'react'
import { CUSTOM_EVENT_NAME } from '@typesApp/AppEvent'
import { useAuthTokenInit } from '@hooks/useAuthTokenInit'
import { useInitialConfiguration } from '@hooks/useInitialConfiguration'
import { useAppEventListener } from '@connector/hooks/useAppEventListener'
import { ModalRootContainer } from '@components/ui-css/Modal/Modal'

/**
 * App used internally for intialization
 */
export const InitializerApp: React.FC = () => {
  const appEventListener = useAppEventListener()

  useAuthTokenInit()
  useInitialConfiguration()

  useEffect(() => {
    document.addEventListener(CUSTOM_EVENT_NAME.APP, appEventListener)
    return () => {
      document.removeEventListener(CUSTOM_EVENT_NAME.APP, appEventListener)
    }
  }, [appEventListener])

  return <ModalRootContainer />
}
